import React from 'react';
import {Container, Row, Col, Button} from 'react-bootstrap';

import './home_styles/homebuttons.css';

export default function HomeButtons() {
  return (
    <>
      <Container className='mt-5'>
        <div className='row'>
            <div className='col-12 d-flex rounded home_btn_col'>
              <Button className='active'>Lorem ipsum, dolor sit amet consectetur</Button>
              <Button>Lorem ipsum, dolor sit amet consectetur</Button>
              <Button>Lorem ipsum, dolor sit amet consectetur</Button>
            </div>
        </div>
      </Container>
    </>
  )
}
